import { motion } from "framer-motion";
import { X, Target } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

const dontOffers = [
  "Gestão de redes sociais",
  "Design / branding",
  "Produção de vídeos",
  "Gestão de WhatsApp",
];

export const PositioningSection = () => {
  return (
    <section
      id="posicionamento"
      data-testid="positioning-section"
      className="relative py-24 lg:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          {/* What we don't do */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6 }}
          >
            <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#EF4444] mb-4 block">
              Transparência
            </span>
            <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white mb-6">
              O que <span className="text-[#EF4444]">não</span> oferecemos
            </h2>
            <p className="text-[#A1A1AA] text-lg mb-8">
              Para entregar o melhor resultado, mantemos nosso foco exclusivo em
              aquisição de clientes através de tráfego pago.
            </p>

            <div className="space-y-4">
              {dontOffers.map((item, index) => (
                <motion.div
                  key={index}
                  {...fadeInUp}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  data-testid={`dont-offer-${index}`}
                  className="dont-item rounded-lg px-5 py-4 flex items-center gap-4"
                >
                  <X className="w-5 h-5 text-[#EF4444] flex-shrink-0" />
                  <span className="text-[#A1A1AA]">{item}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* What we focus on */}
          <motion.div
            {...fadeInUp}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#10B981] mb-4 block">
              Nosso Foco
            </span>
            <h2 className="font-outfit font-bold text-3xl sm:text-4xl text-white mb-6">
              Nosso foco é{" "}
              <span className="text-[#10B981]">exclusivamente</span>
            </h2>

            <div className="glass-card rounded-2xl p-8 lg:p-10 border-l-4 border-l-[#10B981]">
              <div className="flex items-start gap-5">
                <div className="w-16 h-16 rounded-xl bg-[#10B981]/10 border border-[#10B981]/20 flex items-center justify-center flex-shrink-0">
                  <Target className="w-8 h-8 text-[#10B981]" />
                </div>
                <div>
                  <h3 className="font-outfit font-bold text-2xl text-white mb-3">
                    Gerar Clientes
                  </h3>
                  <p className="text-[#A1A1AA] text-lg leading-relaxed">
                    Através de campanhas de tráfego pago estratégicas,
                    otimizadas e focadas em conversão. Esse é nosso único
                    objetivo: trazer clientes qualificados para o seu negócio.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
